import { PaymentAttemptStatus } from '@nemuru-eng/js-api-client/slim';

export const PaymentAttemptIcon: Record<PaymentAttemptStatus, string> = {
  [PaymentAttemptStatus.PAYMENT_SUCCESSFUL]: 'credit_score',
  [PaymentAttemptStatus.PAYMENT_FAILED]: 'credit_card_off',
  [PaymentAttemptStatus.SCA_LOADED]: 'account_balance',
  [PaymentAttemptStatus.SCA_CLOSED]: 'account_balance',
  [PaymentAttemptStatus.PAYMENT_CANCELLED]: 'credit_card_off',
};
